module.exports = __webpack_public_path__ + "img/atm-bersama.bb277d66.jpg";